import sample_1 from './spice.jpg';
export const spiceImpressions = {
    sample_1,
};
